<template>
  <fb-form-body>
    <span class="form-title">{{ $t('lang.选择食谱') }}：</span>
    <el-form :model="searchForm"  ref="searchForm"  inline>
      <el-form-item class="search-form-item" :label="$t('lang.语言分类')">
        <el-select clearable v-model="searchForm.lang" :placeholder="$t('lang.请选择')">
          <el-option v-for="item in supportLangList" :key="item.value" :value="item.value" :label="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.分类')">
        <el-select v-model="searchForm.recipeCategoryCode" clearable :placeholder="$t('lang.请选择')">
          <el-option v-for="i in categoryListByLang" :key="i.recipeCategoryCode" :label="i.name" :value="i.recipeCategoryCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.按标签筛选')">
        <el-select v-model="searchForm.recipeTagCode" clearable :placeholder="$t('lang.请选择')">
          <el-option v-for="i in recipeTagList" :key="i.recipeTagCode" :label="i.name" :value="i.recipeTagCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.按型号筛选')">
        <el-select v-model="searchForm.productCodes" clearable :placeholder="$t('lang.请选择')">
          <el-option v-for="i in productList" :key="i.productCode" :label="i.productModel" :value="i.productCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱名称')">
        <el-input :placeholder="$t('lang.食谱名称')" v-model="searchForm.name" clearable></el-input>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱编号')">
        <el-input :placeholder="$t('lang.食谱编号')" v-model="searchForm.number" clearable></el-input>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱类型')">
        <el-select v-model="searchForm.type" clearable>
          <el-option :value="value" :label="$t(`lang.${key}`)" v-for="(key, value, index) in $dict.RECIPE_TYPE" :key="index" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.按时间排序')">
        <el-select v-model="searchForm.sortType" clearable :placeholder="$t('lang.按时间排序')">
          <el-option value="UPDATE_TIME" :label="$t('lang.是')" />
          <el-option value="" :label="$t('lang.否')" />
        </el-select>
      </el-form-item>



      <el-form-item class="search-form-item" label="">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleRecipeList">{{$t('lang.搜索')}}</el-button>
        <el-button size="mini" type="primary" @click="handleResetSearchForm">{{$t('lang.重置')}}</el-button>
      </el-form-item>

    </el-form>



      <el-table border :data="tableData" height="600px" ref="multipleTable"  @select="handleSelect" @select-all="handleSelectAll">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column :label="$t('lang.图片')">
          <template v-slot="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.photo | filterImg "/>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('lang.食谱名称')"></el-table-column>
        <el-table-column prop="number" :label="$t('lang.食谱编号')"></el-table-column>
        <el-table-column prop="recipeCategoryName" :label="$t('lang.分类')"></el-table-column>
        <el-table-column prop="releaseEdition" :label="$t('lang.食谱版本号')"></el-table-column>
        <el-table-column prop="lang" :label="$t('lang.食谱语言')"></el-table-column>
        <el-table-column prop="lang" :label="$t('lang.食谱类型')">
          <template v-slot="{row}">
            {{ row.type | recipeType(that) }}
          </template>
        </el-table-column>
        <el-table-column prop="tags" :label="$t('lang.标签')"></el-table-column>
        <el-table-column prop="lastUpdateTimeStr" :label="$t('lang.更新时间')"></el-table-column>
        <el-table-column prop="makeCount" :label="$t('lang.制作次数')"></el-table-column>
        <el-table-column prop="favoriteCount" :label="$t('lang.收藏数')"></el-table-column>
        <el-table-column prop="evaluationUserCount" :label="$t('lang.评价人数')"></el-table-column>
        <el-table-column prop="avgScore" :label="$t('lang.综合评分')">
          <template v-slot="{row}">{{ row.avgScore || 0 }}</template>
        </el-table-column>

        <el-table-column :label="$t('lang.支持型号')">
          <template v-slot="scope">
            <span>{{ scope.row.productModels | filterProduct }}</span>
          </template>
        </el-table-column>

        <el-table-column label="">
          <template v-slot="{row}">
            <nation-list :high-light="row.confirmLangList" :list="row.supportLangList" disabled />
          </template>
        </el-table-column>
      </el-table>

      <span class="table-num">{{ $t('lang.共') }}{{ total }}{{ $t('lang.条') }}，{{ $t('lang.已选') }}{{ recipeCodes.length }}{{ $t('lang.条') }}</span>

    <el-form ref="form" :model="formData" inline>
      <div style="display: flex">
        <el-form-item :label="$t('lang.离线食谱包型号') + '：'" prop="product">
          <el-select v-model="formData.product" clearable @change="handleChangeProduct"
                     value-key="code" @clear="handleClearProduct">
            <el-option v-for="i in brandProductTree" :key="i.code" :label="i.subBrandName" :value="i"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label-width="0" prop="subBrandProductCode" style="margin-left: 14px">
          <el-select :placeholder="$t('lang.型号')"  v-model="formData.subBrandProductCode" clearable>
            <el-option v-for="i in formData.product['products']" :key="i.code" :label="i.subModel"
                       :value="i.code"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.离线包类型') + '：'" prop="type">
          <el-select :placeholder="$t('lang.离线包类型')" v-model="formData.type" clearable>
            <el-option :label="$t('lang.增量包')" value="increment"></el-option>
            <el-option :label="$t('lang.初始包')" value="init"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.配件类型') + '：'" prop="type">
          <el-select :placeholder="$t('lang.配件类型')" v-model="formData.accessoryType" clearable>
            <el-option v-for="item in accessoryTypeList" :key="item.value" :label="$t(`lang.${item.name}`)" :value="item.value" />
          </el-select>
        </el-form-item>

      </div>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.生成离线食谱包') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>

  </fb-form-body>
</template>

<script>

import {recipeCategoryList, loadBrandOwnerProduct, loadTagsByLang, loadDict} from "../../js/common";
import NationList from "../../components/nation/NationList";

export default {
  name: "OfflineRecipesAdd",
  components: {NationList},
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        detail: this.$api.offlineRecipes.detail,
        update: this.$api.offlineRecipes.update
      },
      formData: {
        product: {},
        subBrandProductCode: '',
        code: '',
        type: ''
      },
      tableData: [],

      searchForm: {
        productCodes: ""
      },

      recipeCategoryList: [],
      productList: [],

      recipeCodes: [],
      total: 0,
      that: this,
      accessoryTypeList: []

    }
  },
  filters: {
    filterProduct(list) {
      if (Array.isArray(list)) {
        return list.join('/');
      }
      return ''
    }
  },
  computed: {
    supportLangList() {
      return this.$store.state.supportLangList;
    },
    brandProductTree() {
      let list = this.$store.state.brandProductTree;
      list = list.map(item => {
        item['subModel'] = item.subBrandName;
        return item;
      });
      return list;
    },
    recipeTagList() {
      return this.$store.state.recipeTagListByLang;
    },
    categoryListByLang() {
      if(!this.searchForm.lang)  return this.recipeCategoryList;
      return this.recipeCategoryList.filter(item => item.mainLang === this.searchForm.lang);
    }
  },
  methods: {

    handleResetSearchForm() {
      for (let key in this.searchForm) {
        if(key === "sortType") {
          this.searchForm[key] = null;
          continue;
        }
        this.searchForm[key] = '';
      }
      this.handleRecipeList();
    },

    // 清除离线食谱包编号
    handleClearProduct() {
      this.formData.subBrandProductCode = '';
    },
    // 离线食谱包编号变化
    handleChangeProduct(item) {
      if (item.products && item.products.length) {
        this.formData.subBrandProductCode = item.products[0].code;
      }
    },
    // 表格单选
    handleSelect(select, s) {
      // 判断取消还是添加
      let hasItem = select.find(i => i.code == s.code);
      if(hasItem) {
        // 添加 还需判断是否已存在
        let flag = this.recipeCodes.includes(s.code);
        if(!flag)  this.recipeCodes.push(s.code);
      } else {
        // 移除
        let removeIndex = this.recipeCodes.indexOf(s.code);
        if(removeIndex != -1) {
          this.recipeCodes.splice(removeIndex, 1);
        }
      }
    },

    // 全选
    handleSelectAll(select) {
      if(select.length) {
        // 全选
        let codes = select.map(item => item.code);
        codes.forEach(item => {
          let flag = this.recipeCodes.includes(item);
          if(!flag) this.recipeCodes.push(item);
        })
      } else {
        // 移除
        this.tableData.forEach((item) => {
          let index = this.recipeCodes.indexOf(item.code);
          if(index != -1) this.recipeCodes.splice(index, 1);
        })
      }
    },

    // 提交生成
    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let {product, type, subBrandProductCode, code, accessoryType} = this.formData;
          let data = {
            productCode: product.code,
            brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
            recipeCodes: this.recipeCodes,
            type,
            subBrandProductCode,
            code,
            accessoryType,
          }

          if (!this.recipeCodes.length) {
            vm.$message.error(vm.$t('lang.未选择食谱内容'));
            return;
          }

          vm.$http.post(vm.api.update, data).then((resp) => {
            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
        }
      });

    }
    ,
    handleReset(form) {
      this.$refs[form].resetFields();
    },

    // 食谱列表
    handleRecipeList() {
      const vm = this;

      let params = {
        onPage: false,
        status: 'released',
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
      }
      for (const key in this.searchForm) {
        if(this.searchForm[key]) params[key] = this.searchForm[key];
      }

      vm.$http.get(vm.api.list, {params: params}).then(res => {
        if (res.data.status != 200) {
          vm.$message.message(res.data.desc);
          return;
        }

        vm.total = res.data.data['pager'].itemCount;
        vm.tableData = res.data.data['recipes'];

        this.$nextTick(() => {
          this.recipeCodes.forEach(item => {
            let recipe = this.tableData.find(t => t.code == item);
            if(recipe) {
              this.$refs.multipleTable.toggleRowSelection(recipe, true);
            }
          })
        })

      })
    },

    handleGetDetail() {
      const vm = this;

      vm.$http.get(vm.api.detail, {params: vm.$route.query}).then(res => {
        if(res.data.status !== 200) {
          vm.$message.error(res.data.desc);
          return;
        }

        let detail = res.data.data.offlineRecipes;

        this.formData = detail;
        this.formData["product"] = vm.brandProductTree.find(item => {
          return item.code === this.formData['subBrandCode'];
        });
        this.recipeCodes = detail.recipeCodes;
        this.handleRecipeList();
      })
    },

  },
  async created() {
    this.recipeCategoryList = await recipeCategoryList(this);
    this.productList = await loadBrandOwnerProduct(this, this.$store.state.userInfo['brandOwnerCode']);
    this.handleGetDetail();
    loadTagsByLang(this)
    this.accessoryTypeList = await loadDict(this, "ACCESSORY_TYPE");
  }
}
</script>

<style scoped>

.fb-form {
  max-width: 500px;
}

.form-title {
  display: inline-block;
  font-weight: bold;
  margin-bottom: 24px;
}

.nav-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dddddd;
  margin-bottom: 24px;
}

.table-num {
  display: inline-block;
  margin: 14px 0 24px;
  font-size: 14px;
  font-weight: bold;
  color: #2f86de;
}

/deep/ .el-radio-button__inner {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  margin-bottom: 8px;
  margin-right: 8px;
}

</style>
